module.exports = __webpack_public_path__ + "static/img/alien-carapace_256.23a9331.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/alien-carapace_256.png
// module id = CFfy
// module chunks = 0